module.exports = __webpack_public_path__ + "media/assets/images/progress-percent-18eeb4f6e4a80514ecc401692d381d9a.svg";